import React from "react";
import { About } from "../Components/About/About";

const AboutUs = () => {
	return <About />;
};

export default AboutUs;
